import React, { memo, useState, useEffect, Fragment, useRef } from "react";
import { v4 as uuid } from "uuid";
// others
import dayjs from "dayjs";
import { Loading } from "./index";
import { useForm } from "react-hook-form";
import Button from "../../../../molecules/Button";
import { getBookingDetail } from "../../ducks/actions";
import { getOrgByID } from "../../../Maintenance/Tickets/ducks/actions";
import { useDispatch, useSelector } from "react-redux";
import { updatePdcService } from "../../ducks/services";
import { Add, Empty, Delete } from "../../../../../assets/svg";
import { Col, Row, Form, Space, message, Typography, Button as IButton, Card, Switch } from "antd";
import { DateField, InputField, RangePickerField, ReactSelectField } from "../../../../atoms/FormElement";
import { InputNumberFieldV2 as InputNumberField } from "../../../../atoms/FormElement/InputNumberField";
import { payment_modes, numberWithCommas, filterPaymentPayload, autoFillAdditionalLineItems } from "../utils";
import { getConfigData } from "../../../BookingForm/ducks/actions";
import { useGetPaymentTypeOptions } from "../../../../../hooks/useGetPaymentTypeOptions";
import { DATE_FORMATS } from "../../../../libs/utils";

const { Text } = Typography;

interface IProps {
  renewal: boolean;
  parentState: (obj: object) => void;
}

let initialState = {
  visible: false,
  paymentData: {
    id: uuid(),
    actualAmount: "",
    description: "",
    modeOfPayment: payment_modes[1].value,
    taxIncl: false,
    isDeleted: false,
  },
  paymentSchedule: [
    {
      id: uuid(),
      actualAmount: "",
      description: "",
      modeOfPayment: payment_modes[1].value,
      taxIncl: false,
      isDeleted: false,
    },
  ],
  bankList: [],
};

var _ = require("lodash");

const index = (props: IProps) => {
  // hooks initialization
  const dispatch: any = useDispatch();

  // redux states
  const { bookingDetails } = useSelector((state: any) => state.newBooking);
  const configData = useSelector((state: any) => state.dashboard.configData);
  const { paymentTypesOptions } = useGetPaymentTypeOptions({
    usageType: bookingDetails?.propertyDetails?.usagesType,
    configKey: "masterPaymentTypeAttributesWithVat",
  });

  const {
    watch,
    control,
    setValue,
    register,
    getValues,
    resetField,
    handleSubmit,
    formState: { errors },
  } = useForm();

  // states
  let [{ visible, paymentData, paymentSchedule, bankList }, setState] = useState(initialState);

  const updateState = (state: {}) => setState((prevState: any) => ({ ...prevState, ...state }));

  const handleSwitch = (checked, index) => {
    const updatedSchedule = [...paymentSchedule];
    updatedSchedule[index].taxIncl = checked; // update only this row
    updateState({ paymentSchedule: updatedSchedule });
    setValue(`totalAmount-${index}`, "");
    setValue(`actualAmount-${index}`, "");
  };
  useEffect(() => {
    if (!configData?.bankList) {
      dispatch(getConfigData(["bankList"]));
    }

    if (bookingDetails && bookingDetails?.orgId) {
      dispatch(getOrgByID(bookingDetails?.orgId));
    }
    const subscription = watch((value, { name }) => paymentSchedule?.length > 0 && handleFields(name, value[name]));
    return () => subscription.unsubscribe();
  }, [watch, paymentSchedule]);

  useEffect(() => {
    if (configData && configData?.bankList && Object.keys(configData?.bankList)?.length > 0) {
      const bankList = configData?.bankList || {};
      const formattedBankList = Object?.entries(bankList as Record<string, string>).map(([key, label]) => ({
        label,
        value: label.toLowerCase().replace(/\s+/g, "_"),
      }));
      updateState({
        bankList: formattedBankList,
      });
    }
  }, [configData?.bankList]);

  const handleFields = (name: string, value: any) => {
    const splitName = name.split("-");
    const index = parseInt(splitName[1]);
    const copy: Array<any> = [...paymentSchedule];
    const row = paymentSchedule[index];
    switch (splitName[0]) {
      case "vat":
        const actualAmount = Number(getValues(`actualAmount-${index}`)?.toString()?.replace(/,/g, ""));
        const totalVat: number = (actualAmount * Number(value)) / 100;
        if (actualAmount) setValue(`totalAmount-${index}`, Math.round((actualAmount + totalVat) * 100) / 100);
        break;
      case "actualAmount":
        const vat = Number(getValues(`vat-${index || 0}`));
        const taxIncluded = row.taxIncl;
        const actualAmt = Number(value.toString().replace(/,/g, ""));

        if (!taxIncluded) {
          const totalVat = (actualAmt * vat) / 100;
          setValue(`totalAmount-${index}`, Math.round((actualAmt + totalVat) * 100) / 100);
        }
        break;
      case "totalAmount":
        const total = Number(value.toString().replace(/,/g, ""));
        const taxRate = Number(getValues(`vat-${index}`));
        const taxIncive = row.taxIncl;
        // calculate base amount from tax-inclusive total and round to 2 decimals
        const amountWithoutTax = Math.round((total / (1 + taxRate / 100)) * 100) / 100;

        if (taxIncive) {
          setValue(`actualAmount-${index}`, amountWithoutTax || 0);
        }
        break;
      case "modeOfPayment":
        if (value?.value === "cash") {
          register(`documentNo-${index}`, {
            required: false,
            value: "",
            disabled: true,
          });
          register(`bankName-${index}`, {
            required: false,
            value: "",
            disabled: true,
          });
          register(`chequeDate-${splitName[1]}`, {
            value: "",
            disabled: true,
          });
          resetField(`chequeDate-${splitName[1]}`);
          resetField(`bankName-${index}`, { defaultValue: "" });
          resetField(`documentNo-${index}`, { defaultValue: "" });
        } else {
          setValue(`chequeDate-${splitName[1]}`, dayjs(bookingDetails?.leaseTerms?.leaseStartDate));
        }

        copy[index].modeOfPayment = value.value;

        updateState({ paymentSchedule: copy });
        break;
    }
  };

  const onSubmit = async (data: any) => {
    updateState({ visible: true });

    let dataCopy = {
      updateDataOnly: true,
      leaseId: bookingDetails?.leaseId,
      paymentSchedule: filterPaymentPayload(data, paymentSchedule),
    };
   
    try {
      const response = await updatePdcService(dataCopy);
      await dispatch(getBookingDetail(bookingDetails?.leaseId));

      updateState({ visible: false });
      message.success(response.data.message);

      props.parentState({
        modalPayload: { iKey: "", title: "", extraText: "", open: false },
      });
    } catch (error) {
      updateState({ visible: false });
      message.error(error.response?.data?.message);
    }
  };

  const handleSelector = (data: any, index: number) => {
    let getVatInPercentage = paymentTypesOptions?.find((item) => item?.value === data?.value)?.vatInPercentage;
    const obj = autoFillAdditionalLineItems(data.value, bookingDetails?.depositPayments);

    if (getVatInPercentage) {
      setValue(`vat-${index}`, getVatInPercentage);
    } else {
      setValue(`vat-${index}`, 0);
    }
    setValue(`totalAmount-${index}`, "");
    setValue(`actualAmount-${index}`, "");
    // if (obj) {
    //   const vat = obj?.vatInPercentage || 0;
    //   const amount = obj?.deafultAmount || "";

    //   setValue(`vat-${index}`, vat);
    //   setValue(`actualAmount-${index}`, amount);

    //   if (vat && amount) {
    //     const totalVat = (amount * vat) / 100;
    //     setValue(`totalAmount-${index}`, amount + totalVat);
    //   }
    // } else {
    //   setValue(`vat-${index}`, 0);
    //   setValue(`totalAmount-${index}`, "");
    //   setValue(`actualAmount-${index}`, "");
    // }
  };

  const handlePayment = (index?: number) => {
    let copy = [...paymentSchedule];

    if (index !== undefined && index !== null) {
      if (index) copy.splice(index, 1);
      setState((prev) => {
        const updatedSchedule = [...prev.paymentSchedule];
        updatedSchedule[index] = {
          ...updatedSchedule[index],
          isDeleted: true,
        };

        return { ...prev, paymentSchedule: updatedSchedule };
      });
    } else {
      copy.push({ ...paymentData, id: uuid() });
    }

    updateState({ paymentSchedule: copy });
  };

  const isPayment = paymentSchedule.length > 0;

  return (
    <Form
      layout="vertical"
      name="bookingform"
      scrollToFirstError
      onFinish={handleSubmit(onSubmit)}
      className="bf-main view-booking edit-payment-schedule"
    >
      <Loading visible={visible} />

      {paymentSchedule
        .filter((item) => !item.isDeleted)
        .map((item: any, index: number) => {
          const description = item.description
            ? paymentTypesOptions.filter((ele: any) => ele.value === item.description)
            : "";

          const modeOfPayment = item?.modeOfPayment
            ? payment_modes.filter((ele: any) => ele.value === item?.modeOfPayment)
            : payment_modes[1];

          return (
            <Fragment key={item?.id + item.isDeleted}>
              {
                <Card
                  style={{ marginTop: "15px" }}
                  className="custom-card-no-border"
                  extra={
                    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                      <span style={{ color: "black", fontSize: "14px" }}>Tax Inclusive</span>

                      <Switch
                        // checked={taxInc[index]}
                        onChange={(checked) => handleSwitch(checked, index)}
                        defaultChecked={false}
                        checkedChildren="Yes"
                        unCheckedChildren="No"
                      />

                      <IButton
                        style={{
                          paddingRight: "0px",
                          background: "none",
                          border: "none",
                          marginTop: "3px",
                        }}
                        title="Delete"
                        onClick={() => handlePayment(index)}
                      >
                        <Delete width="16px" height="16px" />
                      </IButton>
                    </div>
                  }
                >
                  <Row gutter={[16, 24]}>
                    <Col span={6}>
                      <ReactSelectField
                        control={control}
                        isRequired={true}
                        label={"DESCRIPTION"}
                        initValue={description}
                        rules={{ required: "required" }}
                        fieldname={`description-${index}`}
                        onChange={(e: any) => handleSelector(e, index)}
                        validate={errors[`description-${index}`] && "error"}
                        validMessage={errors[`description-${index}`] && errors[`description-${index}`]?.message}
                        selectOption={
                          props.renewal
                            ? paymentTypesOptions
                            : paymentTypesOptions.filter((item) => item.value !== "renewal_fee")
                        }
                      />
                    </Col>

                    <Col span={4}>
                      <InputNumberField
                        control={control}
                        isRequired={true}
                        disabled={item?.taxIncl}
                        label="AMOUNT"
                        format="currency"
                        inputNumberProps={{ min: 1 }}
                        rules={{ required: "required" }}
                        fieldname={`actualAmount-${index}`}
                        defaultValue={item?.actualAmount || 0}
                      />
                    </Col>

                    <Col span={4}>
                      <InputNumberField
                        control={control}
                        disabled={true}
                        isRequired={true}
                        label="VAT %"
                        inputNumberProps={{ min: 0, max: 100, precision: 2 }}
                        fieldname={`vat-${index}`}
                        rules={{
                          required: "required",
                          min: { value: 0, message: "VAT must be at least 0" },
                          max: { value: 100, message: "VAT cannot exceed 100" },
                        }}
                        defaultValue={item?.vat || 0}
                      />
                    </Col>

                    <Col span={4}>
                      <InputNumberField
                        disabled={item?.taxIncl ? false : true}
                        control={control}
                        // isRequired={true}
                        label="TOTAL AMOUNT"
                        format="currency"
                        rules={{ required: "required" }}
                        fieldname={`totalAmount-${index}`}
                        defaultValue={item?.totalAmount || 0}
                      />
                    </Col>

                    <Col span={6}>
                      <ReactSelectField
                        control={control}
                        label="PAYMENT MODE"
                        isRequired={true}
                        initValue={modeOfPayment}
                        selectOption={payment_modes}
                        rules={{ required: "required" }}
                        fieldname={`modeOfPayment-${index}`}
                        validate={errors[`modeOfPayment-${index}`] && "error"}
                      />
                    </Col>
                  </Row>

                  <Row gutter={[16, 24]}>
                    <Col span={6}>
                      <ReactSelectField
                        control={control}
                        label="BANK NAME"
                        initValue={item?.bankName}
                        selectOption={bankList || []}
                        fieldname={`bankName-${index}`}
                        validate={errors[`bankName-${index}`] && "error"}
                        placeholder={"Bank"}
                        iProps={{
                          isDisabled: item?.modeOfPayment === "cash",
                        }}
                      />
                    </Col>
                    <Col span={4}>
                      <InputField
                        label="DOCUMENT NO"
                        control={control}
                        initValue={item?.documentNo}
                        fieldname={`documentNo-${index}`}
                        disabled={item?.modeOfPayment === "cash"}
                        validate={errors[`documentNo-${index}`] && "error"}
                      />
                    </Col>

                    <Col span={4}>
                      <DateField
                        control={control}
                        label="DUE DATE"
                        isRequired={true}
                        rules={{ required: "required" }}
                        fieldname={`dueDate-${index}`}
                        validate={errors[`dueDate-${index}`] && "error"}
                        validMessage={errors[`dueDate-${index}`] && errors[`dueDate-${index}`]?.message}
                        initValue={
                          bookingDetails?.leaseTerms?.leaseStartDate
                            ? dayjs(bookingDetails?.leaseTerms?.leaseStartDate, "YYYY-MM-DD")
                            : ""
                        }
                      />
                    </Col>

                    <Col span={4}>
                      <DateField
                        control={control}
                        label="CHEQUE DATE"
                        fieldname={`chequeDate-${index}`}
                        disabled={item?.modeOfPayment === "cash"}
                        validate={errors[`chequeDate-${index}`] && "error"}
                        initValue={
                          bookingDetails?.leaseTerms?.leaseStartDate
                            ? dayjs(bookingDetails?.leaseTerms?.leaseStartDate, "YYYY-MM-DD")
                            : ""
                        }
                      />
                    </Col>

                    <Col span={6}>
                      <RangePickerField
                        // isRequired={true}
                        control={control}
                        // disabled={!isEditAction && !isReceivePaymentAction}
                        label="Invoice Period (From/To)"
                        setValue={setValue}
                        fieldname={`invoicePeriod-${index}`}
                        validate={errors.invoicePeriod && "error"}
                        // initValue={rangePickerInitialValue(item, "payment_schedule_invice_period")}
                        // rules={{ required: "Invoice Period Required" }}
                        iProps={{
                          format: DATE_FORMATS.display,
                          placeholder: ["Start Date", "End Date"],
                        }}
                        validMessage={errors.invoicePeriod && errors.invoicePeriod.message}
                      />
                    </Col>
                  </Row>
                </Card>
              }
            </Fragment>
          );
        })}

      <Col span={24}>
        <Button
          label="Add Payment"
          className="add-payment-button"
          onClick={() => handlePayment()}
          icon={<Add width="20px" height="20px" style={{ marginRight: "12px" }} />}
        />
      </Col>

      {isPayment && (
        <Row gutter={24} className="footer">
          <Space size="middle">
            <Button
              label="Cancel"
              className="bf-discard-button"
              onClick={() => props.parentState({ modalPayload: { open: false } })}
            />

            <Button type="submit" label="Update" className="cc-fotter_next-button" />
          </Space>
        </Row>
      )}
    </Form>
  );
};

export default memo(index);
